import apiMiddleware from "../../../api/apiMiddleware";

// list states with pagination and search
const list = async ({ page = 1, search = "" }) => {
  const response = await apiMiddleware.get(
    `state?page=${page}${search ? `&search=${search}` : ""}`
  );
  return response.data;
};  

// create state
const create = async (formData) => {
  const response = await apiMiddleware.post("state", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  return response.data;
};

// get state by id
const getById = async (id) => {
  const response = await apiMiddleware.get(`state/${id}`);
  return response.data;
};

// update state
const update = async ({ id, formData }) => {
  const response = await apiMiddleware.post(
    `state/${id}?_method=put`,
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  );
  return response.data;
};

// delete state
const deleteState = async (id) => {
  const response = await apiMiddleware.delete(`state/${id}`);
  return response.data;
};

// get country options
const getCountryOptions = async () => {
  const response = await apiMiddleware.get("country-options");
  return response.data;
};

const sort = async ({ sort_from, sort_to }) => {
  const response = await apiMiddleware.post(`state-sort?_method=put`, {
    sort_from,
    sort_to,
  });
  return response.data;
};

export { list, create, getById, update, deleteState, getCountryOptions, sort };
